(function(){
'use strict';
function parseDecorated(raw){
var s=String(raw==null?'':raw).trim();
var m=s.match(/^(.*?)([0-9][0-9\s.,\u202f]*)([^0-9]*)$/);
if(!m)return null;
var digits=m[2].replace(/[^0-9]/g,'');
var value=parseInt(digits||'0',10);
if(!isFinite(value))return null;
return {prefix:m[1]||'',value:value,suffix:m[3]||''};
}
function locale(){var l=(document.documentElement.lang||'fr').toLowerCase();return l.indexOf('en')===0?'en-US':'fr-FR';}
function format(n){try{return new Intl.NumberFormat(locale()).format(n);}catch(e){return String(n);}}
function paint(el,raw,n){var d=parseDecorated(raw);el.textContent=d?d.prefix+format(n)+d.suffix:String(raw||'');}
function play(el){
if(!el||el.dataset.ecloCountupPlayed==='true')return;
var raw=el.dataset.countupTarget||el.textContent||'';
var d=parseDecorated(raw);
el.dataset.ecloCountupPlayed='true';
if(!d||d.value<=0||window.matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=raw;return;}
var duration=Math.max(900,Math.min(6000,parseInt(el.dataset.countupDuration||'5000',10)||5000));
var start=performance.now();
function frame(now){var p=Math.min(1,(now-start)/duration);var eased=Math.pow(p,2.2);paint(el,raw,Math.round(d.value*eased));if(p<1)requestAnimationFrame(frame);else el.textContent=raw;}
requestAnimationFrame(frame);
}
function initEl(el){
if(el.dataset.ecloCountupReady==='true')return;
el.dataset.ecloCountupReady='true';
var raw=el.dataset.countupTarget||el.textContent||'';
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=raw;return;}
var d=parseDecorated(raw);
if(d&&d.value>0)paint(el,raw,0);
if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){play(el);io.disconnect();}});},{threshold:.35});
io.observe(el);
}else play(el);
}
function init(scope){Array.prototype.forEach.call((scope||document).querySelectorAll('[data-eclo-countup]'),initEl);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
(function(){
'use strict';
window.addEventListener('load', function(){
window.ECLO_CART_PERF = window.ECLO_CART_PERF || {};
window.ECLO_CART_PERF.p1 = false;
window.ECLO_CART_PERF.fetchRestored = false;
window.ECLO_CART_PERF.klaviyoAtcHotfix = true;
}, {once:true});
})();
(function(){
'use strict';
var installed = false;
var attempts = 0;
var maxAttempts = 20;
function onCartPage(){
var cartPath = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
return window.location.pathname === cartPath || window.location.pathname === cartPath + '/';
}
function cartCount(cart){
if (!cart || typeof cart !== 'object') return null;
var n = Number(cart.item_count != null ? cart.item_count : cart.itemCount);
if (Number.isFinite(n)) return n;
var items = cart.items;
if (!Array.isArray(items)) return null;
return items.reduce(function(total, item){
return total + Number((item && item.quantity) || 0);
}, 0);
}
function syncBroadcastCount(params){
var details = params && (params.cartDetails || params.cart || params);
var count = cartCount(details);
if (!Number.isFinite(count)) return;
document.dispatchEvent(new CustomEvent('theme:cart:change', {
bubbles: true,
detail: {cartCount: count}
}));
}
function install(){
if (installed || onCartPage()) return installed;
if (!window.corner || typeof window.corner.on !== 'function') return false;
var cartItems = document.querySelector('cart-items');
var nativeDrawer = document.querySelector('cart-drawer');
if (!cartItems || typeof cartItems.getCart !== 'function') return false;
if
   (!cartItems.__ecloOriginalGetCart) {
cartItems.__ecloOriginalGetCart = cartItems.getCart.bind(cartItems);
}
cartItems.getCart = function(){
document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles:true}));
};
if (nativeDrawer && nativeDrawer.openCartDrawerOnProductAdded) {
document.removeEventListener('theme:product:added', nativeDrawer.openCartDrawerOnProductAdded);
}
window.corner.on('onCartEdit', syncBroadcastCount);
installed = true;
window.ECLO_CART_PERF = window.ECLO_CART_PERF || {};
window.ECLO_CART_PERF.p2 = true;
window.ECLO_CART_PERF.fastpathInstalled = true;
return true;
}
function retry(){
if (install()) return;
attempts += 1;
if (attempts < maxAttempts) window.setTimeout(retry, 250);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', retry, {once:true});
} else {
retry();
}
})();
(function(){
'use strict';
var ACTIVATION_MS = 30 * 60 * 1000;
var seen = Object.create(null);
var sentActions = Object.create(null);
var canonicalActions = Object.create(null);
var pending = null;
var actionCounter = 0;
var lastFetchSuccessAt = 0;
var lastSuccessfulFetch = null;
var memoryLastAt = 0;
function now(){ return Date.now(); }
function actionId(prefix){
actionCounter += 1;
return (prefix || 'atc') + ':' + now() + ':' + actionCounter;
}
function keyFrom(o){
if(!o || typeof o !== 'object') return '';
var v = o.VariantID != null ? o.VariantID : (o.variant_id != null ? o.variant_id : o.id);
if(v != null && String(v)) return 'v:' + String(v);
var p = o.ProductID != null ? o.ProductID : o.product_id;
return p != null && String(p) ? 'p:' + String(p) : '';
}
function observe(){
window._learnq = window._learnq || [];
var q = window._learnq;
if(!q || typeof q.push !== 'function' || q.push.__ecloV41) return;
var push = q.push;
q.push = function(){
try{
var c = arguments[0];
if(Array.isArray(c) && c[0] === 'track' && c[1] === 'Added to Cart'){
var k = keyFrom(c[2]);
if(k) seen[k] = now();
}
}catch(e){}
return push.apply(this, arguments);
};
q.push.__ecloV41 = true;
}
function baseItem(){
try{
if(typeof item !== 'undefined' && item) return item;
if(window.item) return window.item;
}catch(e){}
return {};
}
function capture(form){
if(!form || !form.querySelector) return;
var id = form.querySelector('input[name="id"],select[name="id"]');
if(!id) return;
var variant = parseInt(id.value,10);
if(!Number.isFinite(variant) || variant <= 0) return;
var qi = form.querySelector('input[name="quantity"],select[name="quantity"]');
var qty = qi ? Number(qi.value) : 1;
pending = {
variant:variant,
qty:Number.isFinite(qty)&&qty>0?qty:1,
at:now()
};
}
function pendingAction(){
if(!pending || now()-pending.at > 10000) return null;
return {variant:pending.variant,qty:pending.qty,at:pending.at};
}
function hasCornerProperties(properties){
if(!properties||typeof properties!=='object') return false;
return Object.prototype.hasOwnProperty.call(properties,'_corner_promo_code')||Object.prototype.hasOwnProperty.call(properties,'_corner_key');
}
function paramsHaveCornerProperties(params){
if(!params) return false;
try{
if(typeof params.has==='function'){
return params.has('properties[_corner_promo_code]')||params.has('properties[_corner_key]')||params.has('_corner_promo_code')||params.has('_corner_key');
}
return params.get('properties[_corner_promo_code]')!=null||params.get('properties[_corner_key]')!=null||params.get('_corner_promo_code')!=null||params.get('_corner_key')!=null;
}catch(e){return false;}
}
function requestIntent(input,init){
var body=init&&init.body;
var lines=[];
function addLine(id,qty,corner){
var variant=parseInt(id,10);
var quantity=Number(qty);
if(!Number.isFinite(variant)||variant<=0) return;
if(!Number.isFinite(quantity)||quantity<=0) quantity=1;
lines.push({variant:variant,qty:quantity,corner:!!corner});
}
function fromObject(data){
if(!data||typeof data!=='object') return;
if(Array.isArray(data.items)){
data.items.forEach(function(x){
if(!x) return;
addLine(x.id!=null?x.id:x.variant_id,x.quantity,hasCornerProperties(x.properties));
});
return;
}
if(data.id!=null||data.variant_id!=null){
addLine(data.id!=null?data.id:data.variant_id,data.quantity,hasCornerProperties(data.properties));
}
}
try{
if(typeof body==='string'){
try{fromObject(JSON.parse(body));}
catch(ignoreJson){
try{
var params=new URLSearchParams(body);
addLine(params.get('id')||params.get('variant_id'),params.get('quantity'),paramsHaveCornerProperties(params));
}catch(ignoreParams){}
}
}else if(typeof FormData!=='undefined'&&body instanceof FormData){
addLine(body.get('id')||body.get('variant_id'),body.get('quantity'),paramsHaveCornerProperties(body));
}else if(typeof URLSearchParams!=='undefined'&&body instanceof URLSearchParams){
addLine(body.get('id')||body.get('variant_id'),body.get('quantity'),paramsHaveCornerProperties(body));
}else{
fromObject(body);
}
}catch(e){}
return {lines:lines};
}
function makeContext(prefix,intent){
var p = pendingAction();
var requested=intent&&Array.isArray(intent.lines)?intent.lines:[];
var first=requested.length?requested[0]:null;
return {
id:actionId(prefix),
at:now(),
variant:first ? first.variant : (p ? p.variant : null),
qty:first ? first.qty : (p ? p.qty : 1),
pendingAt:p ? p.at : null,
requestedLines:requested
};
}
function rememberSuccessfulFetch(ctx){
if(!ctx||ctx.pendingAt==null||ctx.variant==null) return;
lastSuccessfulFetch={
variant:Number(ctx.variant),
qty:Number(ctx.qty)||1,
pendingAt:ctx.pendingAt,
at:now()
};
}
function sameClientActionAsSuccessfulFetch(p){
if(!p||!lastSuccessfulFetch||now()-lastSuccessfulFetch.at>=2500) return false;
return p.at===lastSuccessfulFetch.pendingAt&&
Number(p.variant)===lastSuccessfulFetch.variant&&
Number(p.qty)===lastSuccessfulFetch.qty;
}
function isAdd(url){
try{
var p = new URL(typeof url==='string'?url:(url&&url.url)||'',location.origin).pathname.replace(/\/+$/,'');
return p.endsWith('/cart/add.js') || p.endsWith('/cart/add');
}catch(e){ return false; }
}
function normalizeLines(data){
if(!data) return [];
if(Array.isArray(data.items)) return data.items.filter(Boolean);
if(data.product_id != null || data.variant_id != null || data.id != null) return [data];
return [];
}
function isCornerLine(line,ctx){
if(line&&hasCornerProperties(line.properties)) return true;
var variant=line&&(line.variant_id!=null?line.variant_id:line.id);
if(ctx&&Array.isArray(ctx.requestedLines)&&variant!=null){
for(var i=0;i<ctx.requestedLines.length;i++){
var requested=ctx.requestedLines[i];
if(requested&&requested.corner&&Number(requested.variant)===Number(variant)) return true;
}
}
return false;
}
function clientLines(lines,ctx){
return lines.filter(function(line){return !isCornerLine(line,ctx);});
}
function findCartLine(cart,ctx,base){
var items=cart&&Array.isArray(cart.items)?cart.items:[];
if(ctx && ctx.variant){
for(var i=0;i<items.length;i++){
if(Number(items[i]&&items[i].variant_id)===Number(ctx.variant)) return items[i];
}
}
var pid=base&&base.ProductID!=null?Number(base.ProductID):0;
if(pid){
var matches=items.filter(function(x){return Number(x&&x.product_id)===pid;});
if(matches.length===1) return matches[0];
}
return items.length===1?items[0]:null;
}
function absolute(u){
if(!u) return null;
try{return new URL(u,location.origin).href;}catch(e){return u;}
}
function checkoutUrl(){
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
return absolute(String(root).replace(/\/?$/,'/')+'checkout');
}
function centsOf(line){
if(!line) return 0;
var n=Number(line.final_price!=null?line.final_price:line.price);
return Number.isFinite(n)?n:0;
}
function euros(c){
var n=Number(c);
return Number.isFinite(n)?'€'+(n/100).toFixed(2).replace('.',','):null;
}
function valueString(c){
var n=Number(c);
return Number.isFinite(n)?(n/100).toFixed(2).replace('.',','):null;
}
function currency(){
return (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
}
function lineQty(line,ctx){
var variant=line&&(line.variant_id!=null?line.variant_id:line.id);
if(ctx&&Array.isArray(ctx.requestedLines)&&variant!=null){
var requested=0;
ctx.requestedLines.forEach(function(x){
if(x&&Number(x.variant)===Number(variant)) requested+=Number(x.qty)||0;
});
if(requested>0) return requested;
}
if(ctx&&ctx.variant!=null&&variant!=null&&Number(ctx.variant)===Number(variant)&&Number.isFinite(Number(ctx.qty))&&Number(ctx.qty)>0){
return Number(ctx.qty);
}
var q=Number(line&&line.quantity);
if(Number.isFinite(q)&&q>0) return q;
return 1;
}
function addedItem(line,ctx){
if(!line) return null;
var cents=centsOf(line);
var qty=lineQty(line,ctx);
var image=line.image||(line.featured_image&&(line.featured_image.url||line.featured_image));
return {
Name:line.product_title||line.title||'',
ProductID:line.product_id!=null?line.product_id:null,
VariantID:line.variant_id!=null?line.variant_id:(line.id!=null?line.id:null),
VariantName:line.variant_title&&line.variant_title!=='Default Title'?line.variant_title:'',
Price:euros(cents),
UnitValue:cents/100,
URL:line.url?absolute(line.url):null,
ImageURL:image?absolute(image):null,
Brand:line.vendor||'',
Quantity:qty,
LineValue:(cents/100)*qty
};
}
function totals(lines,ctx){
var val=0, quantity=0;
lines.forEach(function(line){
var q=lineQty(line,ctx);
val += (centsOf(line)/100)*q;
quantity += q;
});
return {value:val,quantity:quantity};
}
function chooseMain(lines,ctx){
if(!lines.length) return null;
if(ctx&&ctx.variant){
for(var i=0;i<lines.length;i++){
if(Number(lines[i]&&lines[i].variant_id)===Number(ctx.variant)) return lines[i];
}
}
return lines[0];
}
function legacyPayload(lines,ctx){
if(!lines.length) return null;
var main=chooseMain(lines,ctx);
if(!main) return null;
var out={}, base=baseItem();
Object.keys(base||{}).forEach(function(k){out[k]=base[k];});
var cents=centsOf(main);
var image=main.image||(main.featured_image&&(main.featured_image.url||main.featured_image))||out.ImageURL;
out.Name=main.product_title||out.Name||main.title;
if(main.product_id!=null) out.ProductID=main.product_id;
if(main.variant_id!=null) out.VariantID=main.variant_id;
else if(main.id!=null) out.VariantID=main.id;
if(main.variant_title&&main.variant_title!=='Default Title') out.VariantName=main.variant_title;
var raw=valueString(cents);
if(raw) out.Price=raw;
if(raw) out.Value=raw;
if(main.url) out.URL=absolute(main.url);
if(image) out.ImageURL=absolute(image);
if(main.vendor) out.Brand=main.vendor;
out.Quantity=lineQty(main,ctx);
out.Currency=currency();
var items=lines.map(function(line){return addedItem(line,ctx);}).filter(Boolean);
var t=totals(lines,ctx);
out.ItemNames=items.map(function(added){return added.Name;});
out.Items=items;
out.CheckoutURL=checkoutUrl();
out.ActionCount=1;
out.ActionType=items.length>1?'multi_product':'single_product';
out.AddedItems=items;
out.AddedItemCount=items.length;
out.AddedQuantity=t.quantity;
out.AddedValue=t.value;
out.AddedValueFormatted=euros(Math.round(t.value*100));
if(out.$value==null) out.$value=t.value;
return out.Name?out:null;
}
function dataLayerItems(lines,ctx){
return lines.map(function(line){
var cents=centsOf(line);
return {
item_id:line.product_id!=null?String(line.product_id):'',
item_name:line.product_title||line.title||'',
item_brand:line.vendor||'',
item_variant:line.variant_title&&line.variant_title!=='Default Title'?line.variant_title:'',
price:cents/100,
quantity:lineQty(line,ctx),
eclo_variant_id:line.variant_id!=null?String(line.variant_id):(line.id!=null?String(line.id):''),
eclo_product_url:line.url?absolute(line.url):''
};
});
}
function activationStorageKey(){
try{
var u=new URL(location.href);
var preview=u.searchParams.get('preview_theme_id');
return preview?'eclo_cart_activation_v1_preview_'+preview:'eclo_cart_activation_v1';
}catch(e){
return 'eclo_cart_activation_v1';
}
}
function readLastAt(){
try{
var raw=localStorage.getItem(activationStorageKey());
var parsed=parseInt(raw||'0',10);
return Number.isFinite(parsed)?parsed:0;
}catch(e){
return memoryLastAt||0;
}
}
function writeLastAt(ts){
memoryLastAt=ts;
try{localStorage.setItem(activationStorageKey(),String(ts));}catch(e){}
}
function pushDataLayer(eventName,lines,ctx,t){
window.dataLayer=window.dataLayer||[];
var items=dataLayerItems(lines,ctx);
var payload={
event:eventName,
eclo_event_version:'1.0',
eclo_action_id:ctx.id,
eclo_action_count:1,
eclo_action_type:items.length>1?'multi_product':'single_product',
eclo_added_item_count:items.length,
eclo_added_quantity:t.quantity,
eclo_added_value:t.value,
eclo_activation_window_minutes:30,
eclo_source_path:location.pathname,
ecommerce:{
currency:currency(),
value:t.value,
items:items
}
};
window.dataLayer.push({ecommerce:null});
window.dataLayer.push(payload);
window.ECLO_CART_METRICS=window.ECLO_CART_METRICS||{};
if(eventName==='eclo_add_to_cart_action') window.ECLO_CART_METRICS.lastAddToCartAction=payload;
if(eventName==='eclo_cart_activated') window.ECLO_CART_METRICS.lastCartActivation=payload;
}
function canonical(lines,ctx){
if(!lines.length || canonicalActions[ctx.id]) return;
canonicalActions[ctx.id]=true;
var t=totals(lines,ctx);
var ts=now();
var last=readLastAt();
var activated=!last || (ts-last)>ACTIVATION_MS;
pushDataLayer('eclo_add_to_cart_action',lines,ctx,t);
if(activated) pushDataLayer('eclo_cart_activated',lines,ctx,t);
writeLastAt(ts);
}
function legacyAlreadySeen(lines,ctx){
var threshold=(ctx&&ctx.at?ctx.at:now())-250;
for(var i=0;i<lines.length;i++){
var k=keyFrom(lines[i]);
if(k&&(seen[k]||0)>=threshold) return true;
}
return false;
}
function emitLegacy(lines,ctx){
if(!lines.length || sentActions[ctx.id]) return;
observe();
if(legacyAlreadySeen(lines,ctx)) return;
var p=legacyPayload(lines,ctx);
if(!p) return;
sentActions[ctx.id]=true;
window._learnq.push(['track','Added to Cart',p]);
}
function handleSuccess(lines,ctx){
if(!lines.length) return;
lastFetchSuccessAt=now();
var eligible=clientLines(lines,ctx);
if(!eligible.length) return;
canonical(eligible,ctx);
window.setTimeout(function(){emitLegacy(eligible,ctx);},1300);
}
function fromCart(ctx){
if(typeof window.fetch!=='function' || !ctx || !ctx.variant) return;
var base=baseItem();
window.fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'})
.then(function(r){return r&&r.ok?r.json():null;})
.then(function(cart){
if(!cart) return;
var line=findCartLine(cart,ctx,base);
if(line) handleSuccess([line],ctx);
}).catch(function(){});
}
function installFetch(){
if(typeof window.fetch!=='function' || window.fetch.__ecloAtcV41) return;
var nativeFetch=window.fetch;
function wrapped(){
var args=arguments, add=isAdd(args[0]);
var intent=add?requestIntent(args[0],args[1]):null;
var ctx=add?makeContext('fetch',intent):null;
var response=nativeFetch.apply(this,args);
/* v0.26 : compteur d'inflight /cart* (toutes requêtes, pas seulement ADD) — signal
   réutilisé par la garde de clic checkout et le jalon cart_click. Idempotent via marqueur. */
try{var __u=(args[0]&&args[0].url)||args[0]||'';if(typeof __u==='string'&&__u.indexOf('/cart')>-1&&response&&typeof response.then==='function'){window.__ecloCartInflight=(window.__ecloCartInflight||0)+1;window.__ecloLastCartReq=now();var __dec=function(){window.__ecloCartInflight=Math.max(0,(window.__ecloCartInflight||1)-1);window.__ecloLastCartReq=now();};response.then(__dec,__dec);}}catch(__e){}
if(add&&response&&typeof response.then==='function'){
response.then(function(r){
if(!r||!r.ok) return;
rememberSuccessfulFetch(ctx);
r.clone().json().then(function(data){
var lines=normalizeLines(data);
if(lines.length) handleSuccess(lines,ctx);
else if(ctx&&ctx.variant) window.setTimeout(function(){fromCart(ctx);},250);
}).catch(function(){
if(ctx&&ctx.variant) window.setTimeout(function(){fromCart(ctx);},250);
});
}).catch(function(){});
}
return response;
}
wrapped.__ecloAtcV41=true;
window.fetch=wrapped;
}
document.addEventListener('submit',function(e){capture(e&&e.target);},true);
document.addEventListener('click',function(e){
var t=e&&e.target;
if(!t||!t.closest) return;
var b=t.closest('[name="add"],[data-add-to-cart],button[type="submit"]');
if(b) capture(b.form||b.closest('form'));
},true);
observe();
installFetch();
document.addEventListener('theme:product:added',function(){
if(now()-lastFetchSuccessAt<2500) return;
var p=pendingAction();
if(!p) return;
if(sameClientActionAsSuccessfulFetch(p)) return;
var ctx={id:actionId('theme'),at:now(),variant:p.variant,qty:p.qty};
window.setTimeout(function(){fromCart(ctx);},250);
});
document.addEventListener('DOMContentLoaded',observe,{once:true});
window.addEventListener('load',observe,{once:true});
window.ECLO_CART_PERF=window.ECLO_CART_PERF||{};
window.ECLO_CART_PERF.klaviyoAtcHotfixV4=false;
window.ECLO_CART_PERF.klaviyoAtcHotfixV41=true;
window.ECLO_CART_PERF.klaviyoAtcHotfixV411=true;
window.ECLO_CART_METRICS=window.ECLO_CART_METRICS||{};
window.ECLO_CART_METRICS.version='1.0';
window.ECLO_CART_METRICS.activationWindowMinutes=30;
})();

/* ECLO ATC V4.1.2 — physical units enrichment only.
   Does NOT change ATC counting, deduplication, AddedValue or Cart Activation.
   1 mois = 1 physical unit, 2 mois = 2, 3 mois = 3. */
(function(){
  'use strict';

  if (window.ECLO_ATC_PHYSICAL_UNITS_V412) return;
  window.ECLO_ATC_PHYSICAL_UNITS_V412 = true;

  function packMultiplier(title){
    var value = String(title || '').trim();
    var match = value.match(/^([123])\s*(?:mois|month|months)$/i);
    return match ? Number(match[1]) : 1;
  }

  function positiveQuantity(value){
    var quantity = Number(value);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function enrichKlaviyoPayload(payload){
    if (!payload || typeof payload !== 'object') return payload;

    var items = Array.isArray(payload.AddedItems) ? payload.AddedItems : [];
    if (!items.length) return payload;

    var totalPhysicalUnits = 0;

    items.forEach(function(item){
      if (!item || typeof item !== 'object') return;

      var quantity = positiveQuantity(item.Quantity);
      var multiplier = packMultiplier(item.VariantName);
      var physicalUnits = quantity * multiplier;

      item.PackMultiplier = multiplier;
      item.PhysicalUnits = physicalUnits;
      totalPhysicalUnits += physicalUnits;
    });

    payload.AddedPhysicalUnits = totalPhysicalUnits;
    return payload;
  }

  function enrichDataLayerPayload(payload){
    if (!payload || typeof payload !== 'object') return payload;

    if (
      payload.event !== 'eclo_add_to_cart_action' &&
      payload.event !== 'eclo_cart_activated'
    ) {
      return payload;
    }

    var ecommerce = payload.ecommerce;
    var items = ecommerce && Array.isArray(ecommerce.items)
      ? ecommerce.items
      : [];

    var totalPhysicalUnits = 0;

    items.forEach(function(item){
      if (!item || typeof item !== 'object') return;

      var quantity = positiveQuantity(item.quantity);
      var multiplier = packMultiplier(item.item_variant);
      var physicalUnits = quantity * multiplier;

      item.eclo_pack_multiplier = multiplier;
      item.eclo_physical_units = physicalUnits;
      totalPhysicalUnits += physicalUnits;
    });

    payload.eclo_event_version = '1.1';
    payload.eclo_added_physical_units = totalPhysicalUnits;

    return payload;
  }

  function installLearnqEnrichment(){
    window._learnq = window._learnq || [];
    var queue = window._learnq;

    if (
      !queue ||
      typeof queue.push !== 'function' ||
      queue.push.__ecloPhysicalUnitsV412
    ) {
      return;
    }

    var previousPush = queue.push;

    function enrichedPush(){
      try {
        var command = arguments[0];

        if (
          Array.isArray(command) &&
          command[0] === 'track' &&
          command[1] === 'Added to Cart'
        ) {
          enrichKlaviyoPayload(command[2]);
        }
      } catch (e) {}

      return previousPush.apply(this, arguments);
    }

    enrichedPush.__ecloPhysicalUnitsV412 = true;
    queue.push = enrichedPush;
  }

  function installDataLayerEnrichment(){
    window.dataLayer = window.dataLayer || [];
    var layer = window.dataLayer;

    if (
      !layer ||
      typeof layer.push !== 'function' ||
      layer.push.__ecloPhysicalUnitsV412
    ) {
      return;
    }

    var previousPush = layer.push;

    function enrichedPush(){
      try {
        for (var i = 0; i < arguments.length; i += 1) {
          enrichDataLayerPayload(arguments[i]);
        }
      } catch (e) {}

      return previousPush.apply(this, arguments);
    }

    enrichedPush.__ecloPhysicalUnitsV412 = true;
    layer.push = enrichedPush;
  }

  function install(){
    installLearnqEnrichment();
    installDataLayerEnrichment();

    window.ECLO_CART_PERF = window.ECLO_CART_PERF || {};
    window.ECLO_CART_PERF.klaviyoAtcHotfixV411 = false;
    window.ECLO_CART_PERF.klaviyoAtcHotfixV412 = true;

    window.ECLO_CART_METRICS = window.ECLO_CART_METRICS || {};
    window.ECLO_CART_METRICS.version = '1.1';
  }

  install();

  document.addEventListener('DOMContentLoaded', install, {once:true});
  window.addEventListener('load', install, {once:true});
})();

/* =========================================================
   BEACON v0.26 — jalons panier émis via window.__AB (balise d'arrivée, même sid).
   drawer_open (do) : ouverture du drawer Corner.
   cart_click (cc)  : clic sur le CTA checkout Corner — payload « t<total>g<0|1>s<0|1>f<0|1> »
     (total centimes, cadeau présent, seuil 70€ atteint, file /cart* en vol).
   page_locked (pl) : 1re tentative de défilement alors que <html> est overflow:hidden
     sans carte drawer visible (verrou résiduel).
   Émis seulement si __AB existe (balise active — PDP/fbclid). Lecture seule.
   ========================================================= */
(function(){
  'use strict';
  function ab(code, payload){ try{ if(window.__AB && window.__AB.px) window.__AB.px(code, payload); }catch(e){} }
  function visible(el){
    if(!el || !el.getBoundingClientRect) return false;
    var s = window.getComputedStyle ? getComputedStyle(el) : null;
    if(s && (s.display==='none' || s.visibility==='hidden' || parseFloat(s.opacity||'1')===0)) return false;
    var r = el.getBoundingClientRect();
    if(!r || (r.width===0 && r.height===0)) return false;
    var vw = window.innerWidth||0, vh = window.innerHeight||0;
    return r.bottom>0 && r.right>0 && r.top<vh && r.left<vw;
  }
  function drawerVisible(){
    var c; try{ c = document.querySelectorAll("[id*='corner'][id*='card'],[id*='corner'][id*='open'],[class*='drawer']"); }catch(e){ return false; }
    for(var i=0;i<c.length;i++) if(visible(c[i])) return true;
    return false;
  }
  /* cache léger du dernier /cart.js pour renseigner cart_click sans requête au clic */
  var cache = { total: null, gift: false, plan: false };
  function refresh(){
    try{ window.fetch('/cart.js').then(function(r){return r&&r.ok?r.json():null;}).then(function(cart){
      if(!cart) return;
      cache.total = cart.total_price;
      cache.gift = (cart.items||[]).some(function(it){ return it.final_line_price===0 || /_corner/i.test(JSON.stringify(it.properties||{})); });
      cache.plan = (cart.items||[]).some(function(it){ return !!it.selling_plan_allocation; }); /* v0.26.1 : selling plan présent (abonnement) */
    }).catch(function(){}); }catch(e){}
  }
  function inFlight(){
    var n = window.__ecloCartInflight||0, last = window.__ecloLastCartReq||0;
    return (n>0 || (last && (Date.now()-last)<500)) ? 1 : 0;
  }
  function isCheckoutCtl(el){
    if(!el) return false;
    var txt = (el.innerText||el.value||'').trim();
    var href = (el.getAttribute && (el.getAttribute('href')||el.getAttribute('formaction')))||'';
    return /\/checkouts?/i.test(href) || el.name==='checkout' || /commander|checkout|paiement|payer/i.test(txt);
  }
  /* drawer_open : brancher onCowiOpen dès que Corner est prêt (polling borné) */
  var tries = 0;
  (function hook(){
    if(window.corner && typeof window.corner.on==='function'){
      try{ window.corner.on('onCowiOpen', function(){ ab('do'); refresh(); }); }catch(e){}
      try{ window.corner.on('onCartEdit', function(){ refresh(); }); }catch(e){}
      return;
    }
    if(tries++ < 40) window.setTimeout(hook, 250);
  })();
  refresh();
  /* cart_click : capture sur le CTA checkout Corner */
  document.addEventListener('click', function(ev){
    try{
      var t = ev.target; if(!t || !t.closest) return;
      var ctl = t.closest('button,a,[role=button],input[type=submit]');
      if(!ctl || !isCheckoutCtl(ctl)) return;
      var total = cache.total==null ? -1 : cache.total;
      var seuil = (cache.total!=null && cache.total>=7000) ? 1 : 0;
      ab('cc', 't'+total+'g'+(cache.gift?1:0)+'s'+seuil+'f'+inFlight()+'p'+(cache.plan?1:0));
    }catch(e){}
  }, true);
  /* page_locked : 1re tentative de défilement avec <html> verrouillé hors drawer */
  function checkLocked(){
    try{
      var o = document.documentElement.style.overflow;
      if(o==='hidden' && !drawerVisible()) ab('pl');
    }catch(e){}
  }
  window.addEventListener('wheel', checkLocked, {passive:true, capture:true});
  window.addEventListener('touchmove', checkLocked, {passive:true, capture:true});
})();